export default __webpack_public_path__ + "static/media/report-copy.2202fc01.svg";